/* app/js/src/components/mediaEditor/files-tab/analyze/analyze.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.container {
  height: 26px;
  border-radius: 4px;
  border: solid 1px #dde3e7;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #f1f3f4;
  font-size: 12px;
  margin-right: 4px;
  padding: 0 5px;
}
.container.fail {
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #ffffff;
}
.container.fail ::ng-deep svg {
  width: 40px;
  height: 30px;
}
.container.fail .delete {
  right: 5px;
}
.container .analyze-svg {
  display: flex;
}
.content {
  max-width: 70px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.content icn-close-btn {
  position: absolute;
}
/*# sourceMappingURL=analyze.component.css.map */
